<template>
  <div class="switch" :class="{ 'active': active }">
    <div class="switch__pill" :class="{ 'active': active }">
      <AtomSpinner class="switch__spinner" :class="{ 'loading': loading, 'active': active, 'coral': active, 'white': !active }" v-if="spinner" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  spinner: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.switch {
  @apply inline-flex items-center;
  @apply rounded-full p-0.5 w-[2.25em] bg-sand/40 border border-sand/40 transition-all;

  &.active {
    @apply bg-coral border-coral pl-[1em];
  }

  &__pill {
    @apply rounded-full w-[1em] h-[1em] bg-coral transition-all p-0.5;

    &.active {
      @apply bg-white;
    }
  }

  &__spinner {
    @apply transition-opacity opacity-0;

    &.loading {
      @apply opacity-100;
    }
  }
}
</style>
